import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { User } from '../../domain/entities/AuthEntity';

export const useAuth = () => {

  // Obtener desde React Query (reactivo)
  const { data: user } = useQuery<User | null>({
    queryKey: ['auth'],
    queryFn: async () => {
      // Carga inicial desde localStorage
      const stored = localStorage.getItem('user');
      return stored ? JSON.parse(stored) : null;
    },
    initialData: () => {
      const stored = localStorage.getItem('user');
      return stored ? JSON.parse(stored) : null;
    },
    staleTime: Infinity,
  });

  // Sincronizar localStorage cuando user cambia
  useEffect(() => {
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    } else {
      localStorage.removeItem('user');
    }
  }, [user]);

  return {
    user,
    isAuthenticated: !!user,
  };
};
